import { useState } from "react";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";
import { LogoMark } from "../Logo";
import { API } from "../../lib/company";
import { errMsg, setToken } from "../../lib/admin";

export const AdminLogin = ({ onLogin }) => {
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { password: pwd });
      setToken(data.token);
      onLogin();
    } catch (e2) { setErr(errMsg(e2)); }
    setLoading(false);
  };
  return (
    <div className="min-h-screen grid place-items-center px-5 pt-20" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-[28px] bg-white border border-[var(--line)] p-8 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.25)]">
        <LogoMark className="w-12 h-12" />
        <h1 className="mt-6 font-display text-3xl font-semibold tracking-tight">Area riservata</h1>
        <p className="mt-1 text-sm text-[var(--muted)]">Inserisci la password amministratore.</p>
        <label className="mt-6 flex items-center gap-3 rounded-full border border-[var(--line)] px-5 h-12 focus-within:border-[var(--ink)]">
          <Lock className="w-4 h-4 text-[var(--muted)]" />
          <input type="password" autoFocus value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Password" data-testid="admin-password-input" className="outline-none w-full bg-transparent text-sm" />
        </label>
        {err && <p className="mt-3 text-sm text-[var(--red)]" data-testid="admin-login-error">{err}</p>}
        <button disabled={loading || !pwd} data-testid="admin-login-submit-btn"
          className="mt-5 w-full h-12 rounded-full bg-[var(--ink)] text-white text-sm font-semibold hover:bg-[var(--red)] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Accedi
        </button>
      </form>
    </div>
  );
};
